<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card title="KEEP IN TOUCH WITH US" pace="6">
        Is a consulting company providing accounting services and technology
        solutions. We stand beside all businesses to help them shape and drive
        their transformation journey. We are always at the forefront of
        innovation.
      </base-info-card>

      <base-contact-business dense />
      <div class="hover11 column">
        <figure>
          <a
            href="https://api.whatsapp.com/send?phone=6597223997&text=Hi, I will like to enquire on your Accounting Services."
            target="_blank"
          >
            <img
              src="https://www.smart-towkay.com/assets/newImg/whatsapp-mobile-button.png"
              width="190"
          /></a>
        </figure>
      </div>
    </div>
  </v-theme-provider>
</template>

<script>
export default {
  name: "BaseBusinessInfo",

  props: { dark: Boolean },

  data: () => ({
    business: [
      {
        icon: "mdi-map-marker-outline",
        title: "Address",
        text:
          "Kenwyn Accounting Services Pte. Ltd . <br>  No 28, <br> Riverside Road,<br> Singapore,<br> 739085"
      },
      {
        icon: "mdi-cellphone",
        title: "Phone",
        text: "+94-26 205 5830"
      },
      {
        icon: "mdi-email",
        title: "Email",
        text: "info@kenwynaccounting.com"
      }
    ]
  })
};
</script>
